function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _styled from "@emotion/styled/base";
var _excluded = ["items", "multiExpand", "shouldAnimate", "delayInterval", "onChange", "children"];

function cov_25jrxidfb3() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_Accordion.tsx";
  var hash = "c6bf514316a1ea7564dadc6bfd8f882d5cb83559";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_Accordion.tsx",
    statementMap: {
      "0": {
        start: {
          line: 27,
          column: 30
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "1": {
        start: {
          line: 32,
          column: 33
        },
        end: {
          line: 32,
          column: 52
        }
      },
      "2": {
        start: {
          line: 42,
          column: 57
        },
        end: {
          line: 50,
          column: 3
        }
      },
      "3": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 55,
          column: 7
        }
      },
      "4": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 45
        }
      },
      "5": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 18
        }
      },
      "6": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 94,
          column: 6
        }
      },
      "7": {
        start: {
          line: 72,
          column: 41
        },
        end: {
          line: 72,
          column: 56
        }
      },
      "8": {
        start: {
          line: 72,
          column: 69
        },
        end: {
          line: 72,
          column: 73
        }
      },
      "9": {
        start: {
          line: 76,
          column: 51
        },
        end: {
          line: 80,
          column: 11
        }
      },
      "10": {
        start: {
          line: 81,
          column: 10
        },
        end: {
          line: 91,
          column: 12
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 32,
            column: 22
          },
          end: {
            line: 32,
            column: 23
          }
        },
        loc: {
          start: {
            line: 32,
            column: 33
          },
          end: {
            line: 32,
            column: 52
          }
        },
        line: 32
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 29
          },
          end: {
            line: 56,
            column: 3
          }
        },
        line: 52
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 53,
            column: 33
          },
          end: {
            line: 53,
            column: 34
          }
        },
        loc: {
          start: {
            line: 53,
            column: 39
          },
          end: {
            line: 55,
            column: 5
          }
        },
        line: 53
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        loc: {
          start: {
            line: 58,
            column: 18
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 58
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 64,
            column: 17
          },
          end: {
            line: 64,
            column: 18
          }
        },
        loc: {
          start: {
            line: 64,
            column: 23
          },
          end: {
            line: 64,
            column: 25
          }
        },
        line: 64
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 72,
            column: 34
          },
          end: {
            line: 72,
            column: 35
          }
        },
        loc: {
          start: {
            line: 72,
            column: 41
          },
          end: {
            line: 72,
            column: 56
          }
        },
        line: 72
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 72,
            column: 62
          },
          end: {
            line: 72,
            column: 63
          }
        },
        loc: {
          start: {
            line: 72,
            column: 69
          },
          end: {
            line: 72,
            column: 73
          }
        },
        line: 72
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 75,
            column: 19
          },
          end: {
            line: 75,
            column: 20
          }
        },
        loc: {
          start: {
            line: 75,
            column: 36
          },
          end: {
            line: 92,
            column: 9
          }
        },
        line: 75
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 54,
            column: 6
          },
          end: {
            line: 54,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 6
          },
          end: {
            line: 54,
            column: 30
          }
        }, {
          start: {
            line: 54,
            column: 34
          },
          end: {
            line: 54,
            column: 44
          }
        }],
        line: 54
      },
      "1": {
        loc: {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 62,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 62,
            column: 22
          },
          end: {
            line: 62,
            column: 27
          }
        }],
        line: 62
      },
      "2": {
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 63,
            column: 22
          },
          end: {
            line: 63,
            column: 25
          }
        }],
        line: 63
      },
      "3": {
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 64,
            column: 17
          },
          end: {
            line: 64,
            column: 25
          }
        }],
        line: 64
      },
      "4": {
        loc: {
          start: {
            line: 81,
            column: 17
          },
          end: {
            line: 91,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 12
          },
          end: {
            line: 88,
            column: 14
          }
        }, {
          start: {
            line: 90,
            column: 12
          },
          end: {
            line: 90,
            column: 68
          }
        }],
        line: 81
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c6bf514316a1ea7564dadc6bfd8f882d5cb83559"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_25jrxidfb3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_25jrxidfb3();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Accordion as BaseAccordion } from 'react-accessible-accordion';
import aos from 'aos';
import AccordionItem from './UNSAFE_AccordionItem';
var AnimatedAccordionItem = (cov_25jrxidfb3().s[0]++, /*#__PURE__*/_styled(AccordionItem, process.env.NODE_ENV === "production" ? {
  target: "e83j6rd0"
} : {
  target: "e83j6rd0",
  label: "AnimatedAccordionItem"
})("opacity:0;transition-property:opacity,transform;transition-duration:0.4s;transition-timing-function:ease;transition-delay:", function (props) {
  cov_25jrxidfb3().f[0]++;
  cov_25jrxidfb3().s[1]++;
  return props.delayInterval;
}, "s;transform:translate3d(0, 100px, 0);&.aos-animate{opacity:1;transform:translateZ(0);}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
/** @deprecated  */

var UNSAFE_Accordion = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(UNSAFE_Accordion, _React$PureComponent);

  var _super = _createSuper(UNSAFE_Accordion);

  function UNSAFE_Accordion() {
    _classCallCheck(this, UNSAFE_Accordion);

    return _super.apply(this, arguments);
  }

  _createClass(UNSAFE_Accordion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      cov_25jrxidfb3().f[1]++;
      cov_25jrxidfb3().s[3]++;
      window.requestAnimationFrame(function () {
        cov_25jrxidfb3().f[2]++;
        cov_25jrxidfb3().s[4]++;
        (cov_25jrxidfb3().b[0][0]++, _this.props.shouldAnimate) && (cov_25jrxidfb3().b[0][1]++, aos.init());
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_25jrxidfb3().f[3]++;

      var _ref = (cov_25jrxidfb3().s[5]++, this.props),
          items = _ref.items,
          multiExpand = _ref.multiExpand,
          _ref$shouldAnimate = _ref.shouldAnimate,
          shouldAnimate = _ref$shouldAnimate === void 0 ? (cov_25jrxidfb3().b[1][0]++, false) : _ref$shouldAnimate,
          _ref$delayInterval = _ref.delayInterval,
          delayInterval = _ref$delayInterval === void 0 ? (cov_25jrxidfb3().b[2][0]++, 0.3) : _ref$delayInterval,
          _ref$onChange = _ref.onChange,
          onChange = _ref$onChange === void 0 ? (cov_25jrxidfb3().b[3][0]++, function () {
        cov_25jrxidfb3().f[4]++;
      }) : _ref$onChange,
          _unusedChildren = _ref.children,
          accordionItemProps = _objectWithoutProperties(_ref, _excluded);

      cov_25jrxidfb3().s[6]++;
      return /*#__PURE__*/React.createElement(BaseAccordion, {
        allowMultipleExpanded: multiExpand,
        allowZeroExpanded: true // true allow users to close any open group
        ,
        preExpanded: items.filter(function (i) {
          cov_25jrxidfb3().f[5]++;
          cov_25jrxidfb3().s[7]++;
          return i.startExpanded;
        }).map(function (i) {
          cov_25jrxidfb3().f[6]++;
          cov_25jrxidfb3().s[8]++;
          return i.id;
        }),
        onChange: onChange
      }, items.map(function (item, index) {
        cov_25jrxidfb3().f[7]++;
        var commonProps = (cov_25jrxidfb3().s[9]++, _objectSpread(_objectSpread({
          index: index
        }, item), accordionItemProps));
        cov_25jrxidfb3().s[10]++;
        return shouldAnimate ? (cov_25jrxidfb3().b[4][0]++, /*#__PURE__*/React.createElement(AnimatedAccordionItem, _extends({
          key: "item_".concat(index),
          "data-aos": "fade-up",
          "data-aos-delay": "".concat(delayInterval * (index + 1), "s"),
          delayInterval: delayInterval
        }, commonProps))) : (cov_25jrxidfb3().b[4][1]++, /*#__PURE__*/React.createElement(AccordionItem, _extends({
          key: "item_".concat(index)
        }, commonProps)));
      }));
    }
  }]);

  return UNSAFE_Accordion;
}((React.PureComponent));

_defineProperty(UNSAFE_Accordion, "defaultProps", (cov_25jrxidfb3().s[2]++, {
  alignBody: false,
  alignLeft: false,
  arrowPosition: 'left',
  headingLevel: 3,
  multiExpand: false,
  noBorder: false,
  paddingSize: 5
}));

export default UNSAFE_Accordion;